import { GET_SITE_SETTINGS_DATA, GET_AUTO_SITE_SETTINGS_DATA, UPDATE_SITE_SETTINGS_API_STATE } from "src/actions/type";

const siteSettingsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_SITE_SETTINGS_DATA:
      return action.payload;
    case GET_AUTO_SITE_SETTINGS_DATA:
      return { ...state, ...action.payload }
    case UPDATE_SITE_SETTINGS_API_STATE:
      return { ...state, api_state: action.payload }
    default:
      return state;
  }
};

export default siteSettingsReducer;
